import axios from 'axios'
import api from '../api'
import interceptors from './interceptors'

const AXIOS_CONFIG = {
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_BASE_URL,
}

const setupApp = async () => {
  const _axios = axios.create(AXIOS_CONFIG)

  if (process.env.NODE_ENV === 'development') {
    const { default: server } = await import('../server')
    server(_axios)
  }

  const _api = api(_axios)
  interceptors(_axios, _api)

  return {
    axios: _axios,
    api: _api,
  }
}

export { setupApp }
